import PremiumVersionIcon from "@/components/PremiumVersionIcon";
import ShopDTO from "@/dto/shop/ShopDTO";
import OrderTab from "@/scenes/OrderManagement/enum/OrderTab";
import { useOrderManagementStore } from "@/scenes/OrderManagement/store/OrderManagementStore";
import { PremiumFunctionType, usePremiumValidator } from "@/services/PremiumValidator";
import { Radio, Spin } from "antd";
import { observer } from "mobx-react-lite";
import React, { useMemo } from "react";
import { useHistory } from "react-router";

interface LogisticsWarningSelectProps {
    shop: ShopDTO;
    tab: OrderTab;
}

const LogisticsWarningSelect: React.FC<LogisticsWarningSelectProps> = function (props) {
    const { tab, shop } = props;
    const history = useHistory();
    const { validate: handleValidate, loading: validateLoading } = usePremiumValidator();
    const orderManagementStore = useOrderManagementStore();
    const isLoading = validateLoading;

    const renderWarningLabel = (text: string, count: number | string | undefined, showPremium: boolean = false) => (
        <span>
            {text} ({count})
            {showPremium && <PremiumVersionIcon style={{ position: "absolute", top: "-10px", zIndex: 10 }} />}
        </span>
    );

    // Radio选项配置
    const radioOptions = useMemo(
        () =>
            [
                orderManagementStore.orderListCount?.totalLogisticsWarningOrders
                    ? {
                          label: renderWarningLabel(
                              "发货后物流预警",
                              orderManagementStore.orderListCount?.totalLogisticsWarningOrders,
                              true,
                          ),
                          value: OrderTab.LOGISTICS_WARNING,
                      }
                    : null,
                orderManagementStore.orderListCount?.pickupDeadlineWarningOrderCount
                    ? {
                          label: renderWarningLabel(
                              "发货后超时揽收预警",
                              orderManagementStore.orderListCount?.pickupDeadlineWarningOrderCount,
                          ),
                          value: OrderTab.PICKUP_DEADLINE_WARNING,
                      }
                    : null,
            ].filter(Boolean),
        [orderManagementStore.orderListCount],
    );

    const handleChange = async (e) => {
        const selectedTab = e.target.value;

        if (selectedTab === OrderTab.LOGISTICS_WARNING) {
            if (isLoading) return;

            const shouldNext = await handleValidate({
                type: PremiumFunctionType.LOGISTICS_WARNING_ORDER_LIST,
                shopId: shop.id,
            });

            if (!shouldNext) return;
        }

        history.push(`/order/list?shopId=${shop.id}&tab=${selectedTab}`);
    };

    if (radioOptions.length === 0) {
        return null;
    }

    return (
        <Spin spinning={isLoading}>
            <div className="ml20 mb10">
                <Radio.Group
                    options={radioOptions}
                    optionType="button"
                    buttonStyle="solid"
                    value={tab}
                    onChange={handleChange}
                />
            </div>
        </Spin>
    );
};

export default observer(LogisticsWarningSelect);
